import request from './request.js';

/**
 * @param productID
 * @param body
 * @returns {Promise<unknown>}
 */
function getRate(productID, body) {
    const options = {
        endpoint: `/marketplace/products/${ productID }/rate`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<any>}
 */
function getProduct(productID) {
    const options = {
        endpoint: `/marketplace/products/${ productID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param body
 * @returns {Promise<unknown>}
 */
function purchaseProduct(body) {
    const options = {
        endpoint: `/marketplace/products/purchase`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param productID
 * @param failedKnockOutQuestions
 * @returns {Promise<unknown>}
 */
function blockProductCoverage(productID, failedKnockOutQuestions) {
    const options = {
        endpoint: `/marketplace/products/block/${ productID }`,
        method: 'POST',
        body: {
            failedKnockOutQuestions
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param productID
 * @param signage
 * @param password
 */
function terminateProduct(productID, signage, password) {
    const options = {
        endpoint: `/marketplace/products/terminate/${ productID }`,
        method: 'DELETE',
        body: {
            signage,
            password
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param productID
 * @returns {Promise<unknown>}
 */
function optIn(productID) {
    const options = {
        endpoint: `/marketplace/products/accept/${ productID }`,
        method: 'POST',
        body: {}
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param productID
 * @param signage
 * @param password
 * @returns {Promise<unknown>}
 */
function optOut(productID, signage, password) {
    const options = {
        endpoint: `/marketplace/products/refuse/${ productID }`,
        method: 'POST',
        body: {
            signage,
            password
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}


export {
    getRate,
    getProduct,
    purchaseProduct,
    terminateProduct,
    optIn,
    optOut,
    blockProductCoverage
};